export enum PatientPageViewEvents {
  viewActivityPage = 'View Activity Page',
  viewPatientCalendarPage = 'View Patient Calendar Page',
  viewAssessmentsPage = 'View Assessments Page',
  viewCarePlanPage = 'View Care Plan Page',
  viewClinicalProfilePage = 'View Clinical Profile Page',
  viewDocumentsPage = 'View Documents Page',
  viewEnrollmentPage = 'View Enrollment Page',
  viewLabsPage = 'View Labs Page',
  viewMessagesPage = 'View Messages Page',
  viewNotesPage = 'View Notes Page',
  viewOverviewPage = 'View Overview Page',
  viewProfilePage = 'View Profile Page',
  viewTasksPage = 'View Tasks Page',
}

export const patientPageTitles: Record<string, string> = {
  activity: PatientPageViewEvents.viewActivityPage,
  appointments: PatientPageViewEvents.viewPatientCalendarPage,
  assessments: PatientPageViewEvents.viewAssessmentsPage,
  'care-planning': PatientPageViewEvents.viewCarePlanPage,
  'clinical-profile': PatientPageViewEvents.viewClinicalProfilePage,
  documents: PatientPageViewEvents.viewDocumentsPage,
  enrollment: PatientPageViewEvents.viewEnrollmentPage,
  labs: PatientPageViewEvents.viewLabsPage,
  messages: PatientPageViewEvents.viewMessagesPage,
  notes: PatientPageViewEvents.viewNotesPage,
  overview: PatientPageViewEvents.viewOverviewPage,
  profile: PatientPageViewEvents.viewProfilePage,
  tasks: PatientPageViewEvents.viewTasksPage,
};

export const getPatientPageTitle = (page: string): string | undefined => {
  const regex = /^\/maud\/patients\/[^/]+(?:\/([^/]+))?\/?$/;
  const match = page.match(regex);

  if (match) {
    const token = match[1] ?? 'overview';
    return patientPageTitles[token];
  }

  return undefined;
};
